import { render } from "./Coverage.vue?vue&type=template&id=00b7631a&scoped=true"
import script from "./Coverage.vue?vue&type=script&lang=js"
export * from "./Coverage.vue?vue&type=script&lang=js"

import "./Coverage.vue?vue&type=style&index=0&id=00b7631a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b7631a"]])

export default __exports__